import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cm-menu-navigation',

  template: `
    <nav class="menu-navigation text-center">
        <ul>
            <li 
                (click)="afficherEcranRecherche.emit()" 
                [style.background-color]="menuCouleurFond(etatEcranRecherche)">
                <i class="fa fa-search" aria-hidden="true"></i>
            </li>

            <!--<li
                (click)="afficherEcranFiltre.emit()" 
                [style.background-color]="menuCouleurFond(etatEcranFiltre)">
                <i class="fa fa-filter" aria-hidden="true"></i>
            </li>-->

            <li
                (click)="afficherEcranFavoris.emit()" 
                [style.background-color]="menuCouleurFond(etatEcranFavoris)">
                <i class="fa fa-star" aria-hidden="true"></i>
            </li>

            <!--<li>
                <i class="fa fa-pencil" aria-hidden="true"></i>
            </li>-->

            <li 
                (click)="afficherEcranInfoLegende.emit()" 
                [style.background-color]="menuCouleurFond(etatEcranInfoLegende)">
                <i class="fa fa-info" aria-hidden="true"></i>
            </li>
        </ul>
    </nav>
  `,

  styles: [`
    .menu-navigation {
        position: absolute;
        top: 0;
        left: calc(100vw - 60px);
        width: 60px;
        height: calc(100vh - 50px);
        background-color: #006296;
        align-items: center;
        z-index: 5;
        border: 1px solid lightgray;
        display: flex;
    }
    ul {
        list-style-type: none;
        -webkit-padding-start: 8px; /* ??? */
    }
    li {
        color: white;
        font-weight: 700;
        margin-top: 50px;
        cursor: pointer;
        padding: 10px;
    }
    img {
        height: 20px;
    }
    .fa {
        font-size: 26px;
        color: #FFA300;
    }
  `]
})
export class MenuNavigationComponent implements OnInit {

  @Input() etatEcranRecherche: string;
  @Input() etatEcranInfoLegende: string;
  @Input() etatEcranFiltre: string;
  @Input() etatEcranFavoris: string;
  @Output() afficherEcranRecherche: EventEmitter<any> = new EventEmitter();
  @Output() afficherEcranInfoLegende: EventEmitter<any> = new EventEmitter();
  @Output() afficherEcranFiltre: EventEmitter<any> = new EventEmitter();
  @Output() afficherEcranFavoris: EventEmitter<any> = new EventEmitter();


  constructor() {}

  ngOnInit() {
  }

  menuCouleurFond(etat: string) {
    return etat === 'visible'? 'white' : '#006296';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu-navigation.component.ts